import React, { Component } from 'react';
import SizeDropdown from './SizeSelection/SizeDropdown';
import SizeList from './SizeSelection/SizeList';
import CustomProduct from './SizeSelection/CustomProduct';
import { LegalText } from './LegalText';
import ProductList from './ProductList/ProductList';
import LaptopList from './ProductList/LaptopList';
import CompleteProductList from './CompleteProductList/CompleteProductList';
import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import * as modalActions from '../../../redux/modalActions';
import * as sizeHandler from '../../../redux/actions/sizeHandler';
import { bindActionCreators } from 'redux';
import './ModelComponent.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import * as pageControllerActions from '../../../redux/pageControllerActions';
import * as gaHelpers from '../../../utilities/GAHelpers/GAHelpers';
import {
  isSignageSuiteProduct,
  isMultiCanvas,
  convertImperialToGivenUnitSystem
} from '../../../utilities/HelperFunctions/HelperFunctions';
import * as signageHelperFunctions from '../../../utilities/HelperFunctions/SignageHelperFunctions';
import { Icons } from '../../../utilities';
import { Input, InputGroup, InputGroupAddon } from 'reactstrap';

class ModelComponent extends Component {
  constructor() {
    super();
    this.state = {
      customizableWidth: '',
      customizableHeight: '',
      completeProductList: null,
      query: null,
      filteredData: [],
      showWallSizeEdit: false,
      canvasWallWidthInput: '',
      canvasWallHeightInput: ''
    };
  }

  componentDidMount() {
    const {
      customWall,
      dispatchers,
      category,
      productSizes,
      canvasWall,
      unitSystem
    } = this.props;
    const { canvasWallWidth, canvasWallHeight } = canvasWall;

    const widthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      customWall.customWidth,
      unitSystem
    );
    const heightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      customWall.customHeight,
      unitSystem
    );
    const wallWidthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      canvasWallWidth,
      unitSystem
    );
    const wallHeightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
      canvasWallHeight,
      unitSystem
    );
    this.setState({
      customizableWidth: widthInCurrentUnitSystem,
      customizableHeight: heightInCurrentUnitSystem,
      canvasWallWidthInput: wallWidthInCurrentUnitSystem,
      canvasWallHeightInput: wallHeightInCurrentUnitSystem
    });

    dispatchers.pageControllerActions.setModalPageMode(true);
    if (category === 'newposter') {
      const index = productSizes.default.sizes.findIndex(x => x.name === 'A2');
      dispatchers.homeActions.sizeDropdownIsChanged(index);
    }
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  componentDidUpdate(prevProps) {
    const {
      page,
      unitSystem,
      canvasWall,
      customWall,
      canvasWallWidthInput,
      canvasWallHeightInput,
      multiCanvasPopoverStatus,
      dispatchers
    } = this.props;
    const { canvasWallHeight, canvasWallWidth } = canvasWall;
    const { query } = this.state;

    if (prevProps.page !== page) {
      if (query) {
        this.handleProductSearch(query);
      }
    }
    if (prevProps.unitSystem !== unitSystem) {
      const widthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
        customWall.customWidth,
        unitSystem
      );
      const heightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
        customWall.customHeight,
        unitSystem
      );
      this.setState(
        {
          customizableWidth: widthInCurrentUnitSystem,
          customizableHeight: heightInCurrentUnitSystem
        },
        () => {
          this.updateCustomWidthHeight();
        }
      );

      const wallWidthInCurrentUnitSystem = convertImperialToGivenUnitSystem(
        canvasWallWidth,
        unitSystem
      );
      const wallHeightInCurrentUnitSystem = convertImperialToGivenUnitSystem(
        canvasWallHeight,
        unitSystem
      );
      if (
        wallWidthInCurrentUnitSystem != canvasWallWidthInput ||
        wallHeightInCurrentUnitSystem != canvasWallHeightInput
      ) {
        this.setState({
          canvasWallWidthInput: wallWidthInCurrentUnitSystem,
          canvasWallHeightInput: wallHeightInCurrentUnitSystem
        });
      }
    }
    if (prevProps.canvasWallWidthInput != canvasWallWidthInput) {
      dispatchers.sizeHandler.canvasWallWidthChange(canvasWallWidthInput);
    }
    if (prevProps.canvasWallHeightInput != canvasWallHeightInput) {
      dispatchers.sizeHandler.canvasWallHeightChange(canvasWallHeightInput);
    }
    if (prevProps.multiCanvasPopoverStatus != multiCanvasPopoverStatus) {
      if (multiCanvasPopoverStatus) {
        dispatchers.homeActions.setCanvasType(Constants.MULTI_CANVAS);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  updateCustomWidthHeight = () => {
    const { dispatchers } = this.props;
    const { customizableWidth, customizableHeight } = this.state;
    dispatchers.sizeHandler.customWidthChange(customizableWidth);
    dispatchers.sizeHandler.customHeightChange(customizableHeight);
  };

  unitSystemSelector = () => {
    const { dispatchers } = this.props;
    dispatchers.homeActions.toggleUnitSystem();
  };

  hideComponents = () => {
    const { dispatchers, isPresetSizePage } = this.props;

    dispatchers.pageControllerActions.setModalPageMode(!isPresetSizePage);
    this.setState({
      customizableWidth: null,
      customizableHeight: null
    });
    dispatchers.homeActions.setCustomWallSize(null, null);
    dispatchers.homeActions.setSelectedDefaultSize('custom');
  };

  handleCustomSelectNext = () => {
    const { dispatchers } = this.props;
    dispatchers.homeActions.selectPresetWall();
  };

  setCustomHeight = val => {
    this.setState({
      customizableHeight: val
    });
  };

  setCustomWidth = val => {
    this.setState({
      customizableWidth: val
    });
  };

  getFilteredData = query => {
    const { supportedProducts, page } = this.props;
    const { completeProductList } = this.state;
    const list =
      page === Constants.PRODUCT_LIST_PAGE
        ? completeProductList
        : supportedProducts;

    const filteredData = list.filter(element => {
      const modelName = element.name.split(/\s/).join('');
      const modelSKU = element.sku.split(/\s/).join('');
      const modelNumber = element.modelNumber.split(/\s/).join('');

      const checkByName = modelName.toLowerCase().includes(query.toLowerCase());
      const checkBySKU = modelSKU.toLowerCase().includes(query.toLowerCase());
      const checkByNo = modelNumber.toLowerCase().includes(query.toLowerCase());

      return checkByName || checkBySKU || checkByNo;
    });

    this.setState({
      filteredData
    });
  };

  handleProductSearch = inQuery => {
    const query = inQuery.split(/\s/).join('');
    this.setState({ query });
    this.getFilteredData(query);
  };

  applicationGroupName = () => {
    const { storeData } = this.props;
    let applicationListNameValue = '';
    if (storeData.supportEditApplicationGroupName) {
      applicationListNameValue = storeData.applicationGroupCustomName;
    } else {
      applicationListNameValue =
        storeData.applicationGroupName == 'Stickers'
          ? 'adhesive'
          : storeData.applicationGroupName;
    }

    return applicationListNameValue;
  };

  renderTitle = () => {
    const { dispatchers, page } = this.props;
    const mql = window.matchMedia('(max-width: 767px)');
    let title;
    if (dispatchers.homeActions.checkIfLaptopApp()) {
      if (page === Constants.PRODUCT_GROUP_PAGE && mql.matches) {
        title = string.CHOOSE_YOUR_LAPTOP_FAMILY_KEY;
      } else {
        title = string.CHOOSE_YOUR_LAPTOP_KEY;
      }
    } else if (
      dispatchers.homeActions.checkIfCanvasApp() &&
      page === Constants.PRODUCT_GROUP_PAGE
    ) {
      title = string.CHOOSE_CANVAS_TYPE_KEY;
    } else if (isSignageSuiteProduct() && page == Constants.PRODUCT_LIST_PAGE) {
      title = string.formatString(
        string.CHOOSE_GROUP_TYPE,
        this.applicationGroupName()
      );
    } else if (page == Constants.SIZE_SELECTION_PAGE) {
      title = string.formatString(
        string.SELECT_APP_SIZE_KEY,
        dispatchers.homeActions.applicationName()
      );
    }

    return (
      <span>
        <h1 style={{ cursor: 'default', marginBottom: '20px' }}>{title}</h1>
        {dispatchers.homeActions.checkIfLaptopApp() ? (
          <div>
            {this.renderSearchBar()}
            <div className='main-marquee'>
              <div className='pre'>
                <span className='subtitle-notice'>{string.NOTICE_KEY} </span>
                {string.CAUTION_FOR_LAPTOP_SELECTION}
              </div>
            </div>
          </div>
        ) : null}
      </span>
    );
  };

  renderSearchBar = () => (
    <div className='d-flex justify-content-center'>
      <div className='product-search-field-container'>
        <input
          className='product-search-field'
          type='text'
          placeholder={string.SEARCH_YOUR_LAPTOP_KEY}
          aria-label='Search'
          onChange={e => this.handleProductSearch(e.target.value)}
        />
        <div className='separator' />
      </div>
    </div>
  );

  renderProductFamily = (item, pageController, setProductList) => (
    <button
      type='button'
      className='lap-family-container'
      onClick={() => {
        pageController(Constants.PRODUCT_GROUP_PAGE);
        setProductList(this.getProductList(item[0].laptopFamily));
      }}
    >
      <div className='d-flex align-items-center'>
        <img className='laptop-icon' src={Icons.laptop_icon} alt='laptop' />
        <div>
          {item[0].laptopFamily === '' ? 'Others' : item[0].laptopFamily}
        </div>
      </div>
      <img src={Icons.next_arrow_blue} alt='next' />
    </button>
  );

  renderUnitSystemToggler = () => {
    const { unitSystem } = this.props;
    return (
      <div className='unit-system-toggler-container'>
        <hr />
        <div className='sub-container'>
          <label className='switch' htmlFor='toggleUnit'>
            <input
              type='checkbox'
              id='toggleUnit'
              onChange={e => this.unitSystemSelector(e)}
            />
            <span className='slider round' />
          </label>
          <div className='unit-system'>
            {unitSystem === Constants.IMPERIAL_KEY
              ? string.formatString(
                  string.CHANGE_MEASURING_SYSTEM_KEY,
                  string.CENTIMETERS_KEY
                )
              : string.formatString(
                  string.CHANGE_MEASURING_SYSTEM_KEY,
                  string.INCHES_KEY
                )}
          </div>
        </div>
      </div>
    );
  };

  setCompleteProductList = list => {
    this.setState({ completeProductList: list });
  };

  setSelectedProduct = item => {
    const { dispatchers } = this.props;
    dispatchers.homeActions.setSelectedProduct(item).then(() => {
      dispatchers.gaHelpers.selecteModelTypeGA();
    });
  };

  handleSingleProductNavigation = products => {
    const { dispatchers } = this.props;
    const [productFamily] = products;
    const [product] = productFamily;
    dispatchers.homeActions.setSelectedProduct(product);
    dispatchers.pageControllerActions.setCurrentPageIndex(
      Constants.DESIGN_PAGE
    );
    dispatchers.modalActions.setSingleProduct(true);
  };

  sizeIconHandler = size => {
    const { category, dispatchers } = this.props;
    let icon;
    if (
      category == Constants.WALLPAPER_CATEGORY ||
      category == Constants.DOUBLE_SIDED_BANNER_KEY ||
      category == Constants.CANVAS_CATEGORY
    ) {
      icon = dispatchers.sizeHandler.getIconUrlBasedOnOrientationForSizeItem(
        size
      );
    } else {
      icon = dispatchers.sizeHandler.getIconUrlBasedOnRangeForSizeItem(size);
    }
    return icon;
  };

  handleMultiCanvasPopover = () => {
    const { dispatchers, multiCanvasPopoverStatus } = this.props;
    dispatchers.homeActions.setCanvasType(Constants.CANVAS);
    dispatchers.homeActions.setMultiCanvasPopoverStatus(
      !multiCanvasPopoverStatus
    );
  };

  closeMultiCanvasPopover = () => {
    const { dispatchers } = this.props;
    dispatchers.homeActions.setMultiCanvasPopoverStatus(false);
  };

  sizeSelectionUI = () => {
    const {
      productSizes,
      dispatchers,
      storeData,
      unitSystem,
      selectedDefaultSize
    } = this.props;
    if (productSizes.default.sizes.length > 0 || productSizes.custom.sizes) {
      if (dispatchers.signageHelperFunctions.shouldShowSizeList()) {
        return (
          <SizeList
            productSizes={productSizes}
            unitSystem={unitSystem}
            iconFetchHandler={this.sizeIconHandler}
            sizeSelectionHandler={index => {
              dispatchers.sizeHandler.handleProjectSizeSelection(index);
            }}
            customSelectionHandler={this.hideComponents}
            prevPageVisibilityHandler={
              dispatchers.pageControllerActions.canShowPreviousButton
            }
            previousPageHandler={dispatchers.pageControllerActions.goToPrevPage}
          />
        );
      }
      return (
        <SizeDropdown
          productSizes={productSizes}
          unitSystem={unitSystem}
          iconFetchHandler={
            dispatchers.sizeHandler.getIconUrlBasedOnOrientationForSizeItem
          }
          displaySize={storeData.displaySize}
          sizeSelectionHandler={index => {
            dispatchers.sizeHandler.handleProjectSizeSelection(index);
          }}
          dropdDownSelectionHandler={index => {
            dispatchers.homeActions.sizeDropdownIsChanged(index);
          }}
          selectedIndex={selectedDefaultSize}
          customSelectionHandler={this.hideComponents}
          previousPageHandler={dispatchers.pageControllerActions.goToPrevPage}
        />
      );
    }
    return null;
  };

  enableShowEdit = () => {
    this.setState({ showWallSizeEdit: true });
  };

  renderEditCanvasWallSize = () => {
    const { unitSystem, dispatchers, canvasWall } = this.props;
    const {
      canvasWallWidthValid,
      canvasWallHeightValid,
      canvasWallWidthErrorMessage,
      canvasWallHeightErrorMessage,
      canvasWallActiveErrorMessage
    } = canvasWall;
    const { canvasWallWidthInput, canvasWallHeightInput } = this.state;
    let errorMessage = canvasWallActiveErrorMessage;
    if (errorMessage == '') {
      errorMessage =
        canvasWallWidthErrorMessage != ''
          ? canvasWallWidthErrorMessage
          : canvasWallHeightErrorMessage;
    }
    return (
      <div className='canvas-wall-size '>
        <div className='d-flex'>
          <span className='wall-size-font'>Change Wall Size</span>
          <div className='wall-size-inputgroup'>
            <InputGroup>
              <div
                className={`vaild-dimension dimension-valid ${
                  !canvasWallWidthValid ? null : 'invalid-dimension'
                }`}
              >
                <Input
                  type='number'
                  value={canvasWallWidthInput}
                  className='wall-size-input-font'
                  onChange={e => {
                    this.setState({ canvasWallWidthInput: e.target.value });
                    dispatchers.sizeHandler.canvasWallWidthChange(
                      e.target.value
                    );
                  }}
                />
              </div>
              <InputGroupAddon
                addonType='append'
                className='custom-input-group-append'
              >
                <span style={{ margin: 'auto' }}>
                  {' '}
                  {unitSystem === Constants.IMPERIAL_KEY
                    ? string.INCHES_UNIT_STRING_KEY
                    : string.CM_KEY}
                </span>
              </InputGroupAddon>
            </InputGroup>
            <span style={{ width: '50px', margin: '10px' }}> X </span>
            <InputGroup>
              <div
                className={`vaild-dimension dimension-valid ${
                  !canvasWallHeightValid ? null : 'invalid-dimension'
                }`}
              >
                <Input
                  type='number'
                  value={canvasWallHeightInput}
                  className='wall-size-input-font'
                  onChange={e => {
                    this.setState({ canvasWallHeightInput: e.target.value });
                    dispatchers.sizeHandler.canvasWallHeightChange(
                      e.target.value
                    );
                  }}
                />
              </div>
              <InputGroupAddon
                addonType='append'
                className='custom-input-group-append'
              >
                <span style={{ margin: 'auto' }}>
                  {' '}
                  {unitSystem === Constants.IMPERIAL_KEY
                    ? string.INCHES_UNIT_STRING_KEY
                    : string.CM_KEY}
                </span>
              </InputGroupAddon>
            </InputGroup>
          </div>
        </div>
        <div className='wall-size-error'>{errorMessage}</div>
      </div>
    );
  };

  renderDefaultCanvasWallSize = () => {
    const { unitSystem, canvasWall } = this.props;
    const {
      canvasWallActiveErrorMessage,
      canvasWallWidthErrorMessage,
      canvasWallHeightErrorMessage
    } = canvasWall;
    const { canvasWallWidthInput, canvasWallHeightInput } = this.state;
    let errorMessage = canvasWallActiveErrorMessage;
    if (errorMessage == '') {
      errorMessage =
        canvasWallWidthErrorMessage != ''
          ? canvasWallWidthErrorMessage
          : canvasWallHeightErrorMessage;
    }

    return (
      <div className='canvas-wall-size  '>
        <div className='d-flex'>
          <span className='wall-size-font '>
            {string.DEFAULT_WALL_SIZE_KEY}
          </span>
          <div className='wall-size-inputgroup'>
            <div
              className='wall-size-font d-flex wall-size-margin '
              style={{ color: '#2196f3' }}
            >
              <div
                style={{ cursor: 'pointer' }}
                role='button'
                onClick={this.enableShowEdit}
                onKeyPress={() => {}}
                tabIndex='0'
              >
                <span>
                  <u>
                    {canvasWallWidthInput}
                    {unitSystem === Constants.IMPERIAL_KEY
                      ? string.INCHES_UNIT_STRING_KEY
                      : string.CM_KEY}{' '}
                    X {canvasWallHeightInput}
                    {unitSystem === Constants.IMPERIAL_KEY
                      ? string.INCHES_UNIT_STRING_KEY
                      : string.CM_KEY}
                  </u>
                </span>
              </div>
            </div>
            <div
              className='edit-button'
              role='button'
              onClick={this.enableShowEdit}
              onKeyPress={() => {}}
              tabIndex='0'
            >
              <img
                alt=' '
                src={Icons.editDefault}
                style={{ width: '16px', marginLeft: '5px' }}
              />
              <span className='ml-3' style={{ color: '#c3c3c3' }}>
                {string.EDIT_KEY}
              </span>
            </div>
          </div>
        </div>
        <div className='wall-size-error'>{errorMessage}</div>
      </div>
    );
  };

  renderSizeSelectionWindow = () => {
    const { isPresetSizePage, dispatchers } = this.props;
    const {
      customizableWidth,
      customizableHeight,
      showWallSizeEdit
    } = this.state;
    const isCanvas = dispatchers.homeActions.checkIfCanvasApp();
    return (
      <>
        {isPresetSizePage ? (
          <div className='scrolling-wrapper'>{this.sizeSelectionUI()}</div>
        ) : (
          <div className='stacks d-flex justify-content-center align-items-center'>
            <CustomProduct
              hideComponents={this.hideComponents}
              customizableWidth={customizableWidth}
              customizableHeight={customizableHeight}
              setCustomHeight={this.setCustomHeight}
              setCustomWidth={this.setCustomWidth}
            />
          </div>
        )}
        {this.renderUnitSystemToggler()}
        {isCanvas && !showWallSizeEdit
          ? this.renderDefaultCanvasWallSize()
          : null}
        {isCanvas && showWallSizeEdit ? this.renderEditCanvasWallSize() : null}
      </>
    );
  };

  renderError = () => (
    <div className='search-error'>
      {string.PRODUCT_SEARCH_ERROR_MESSAGE_KEY}
    </div>
  );

  isSingleFamilyModels = () => {
    const { supportedProducts, dispatchers } = this.props;
    if (dispatchers.homeActions.checkIfCanvasApp()) {
      return false;
    }
    const groupedByFamily = dispatchers.homeActions.filterSupportedProducts(
      supportedProducts
    );
    return groupedByFamily.length == 1;
  };

  showLaptopList = () => {
    const { dispatchers } = this.props;
    // const { supportedProducts } = this.props;
    const { screenSize } = this.state;

    return dispatchers.homeActions.checkIfLaptopApp() && screenSize <= 767;
    // return true && screenSize <= 767;
  };

  resize() {
    this.setState({ screenSize: window.innerWidth });
  }

  renderModal = () => {
    const {
      dispatchers,
      page,
      supportedProducts,
      multiCanvasPopoverStatus,
      productSizes
    } = this.props;
    const { query, filteredData, completeProductList } = this.state;

    if (page === Constants.PRODUCT_LIST_PAGE) {
      return (
        <CompleteProductList
          isSingleFamilyModels={this.isSingleFamilyModels}
          items={query ? filteredData : completeProductList}
          pageController={dispatchers.pageControllerActions.setCurrentPageIndex}
          setSelectedProduct={this.setSelectedProduct}
          isTurkeyLaptop={dispatchers.signageHelperFunctions.isTurkeyLaptop}
          error={this.renderError}
        />
      );
    }
    if (page == Constants.PRODUCT_GROUP_PAGE) {
      if (this.showLaptopList()) {
        return (
          <LaptopList
            filteredProducts={dispatchers.homeActions.filterSupportedProducts}
            data={dispatchers.homeActions.filterSupportedProducts(
              supportedProducts
            )}
            query={query}
            searchResult={
              query
                ? dispatchers.homeActions.filterSupportedProducts(filteredData)
                : dispatchers.homeActions.filterSupportedProducts(
                    supportedProducts
                  )
            }
            pageController={
              dispatchers.pageControllerActions.setCurrentPageIndex
            }
            completeProductList={this.setCompleteProductList}
            isSingleFamilyModels={this.isSingleFamilyModels}
            handleSingleProduct={dispatchers.homeActions.isProductSingle}
            singleProductNavigation={this.handleSingleProductNavigation}
            isTurkeyLaptop={dispatchers.signageHelperFunctions.isTurkeyLaptop}
          />
        );
      }
      const { productIconUrl } = productSizes.default.iconUrl;
      return (
        <ProductList
          filteredProducts={dispatchers.homeActions.filterSupportedProducts}
          data={dispatchers.homeActions.filterSupportedProducts(
            supportedProducts
          )}
          query={query}
          searchResult={
            query
              ? dispatchers.homeActions.filterSupportedProducts(filteredData)
              : dispatchers.homeActions.filterSupportedProducts(
                  supportedProducts
                )
          }
          pageController={dispatchers.pageControllerActions.setCurrentPageIndex}
          completeProductList={this.setCompleteProductList}
          setSelectedProduct={this.setSelectedProduct}
          isSingleFamilyModels={this.isSingleFamilyModels}
          handleSingleProduct={dispatchers.homeActions.isProductSingle}
          singleProductNavigation={this.handleSingleProductNavigation}
          isTurkeyLaptop={dispatchers.signageHelperFunctions.isTurkeyLaptop}
          error={this.renderError}
          isCanvas={dispatchers.homeActions.checkIfCanvasApp}
          IconUrl={productIconUrl}
          handleMultiCanvasPopover={this.handleMultiCanvasPopover}
          multiCanvasPopoverStatus={multiCanvasPopoverStatus}
          closeMultiCanvasPopover={this.closeMultiCanvasPopover}
        />
      );
    }
    return this.renderSizeSelectionWindow();
  };

  render() {
    const { supportedProducts, dispatchers } = this.props;
    let centerAlignStyle = {};
    if (supportedProducts.length < 6) {
      centerAlignStyle = { alignItems: 'center' };
    }
    return (
      <div className='productStack' style={centerAlignStyle}>
        {this.renderTitle()}
        {this.renderModal()}
        {dispatchers.homeActions.shouldShowLegalText() ? (
          <LegalText finalCheck={false} />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    productSizes: state.modal.productSizes,
    unitSystem: state.home.unitSystem,
    page: state.pageController.currentPageIndex,
    isPresetSizePage: state.pageController.isPresetSizePage,
    category: state.modal.envData.category,
    supportedProducts: state.modal.storeData.supportedProducts,
    storeData: state.modal.storeData,
    selectedDefaultSize: state.home.selectedDefaultSize,
    selectedProduct: state.home.selectedProduct,
    customWall: state.home.customWall,
    multiCanvas: state.home.multiCanvas,
    canvasWall: state.home.canvasWall,
    language: state.home.language,
    multiCanvasPopoverStatus: state.home.multiCanvasPopoverStatus
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      gaHelpers: bindActionCreators(gaHelpers, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      ),
      modalActions: bindActionCreators(modalActions, dispatch),
      sizeHandler: bindActionCreators(sizeHandler, dispatch),
      isMultiCanvas: bindActionCreators(isMultiCanvas, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModelComponent);
